import { render } from "./DateNoTimeValue.vue?vue&type=template&id=d9a722b8"
import script from "./DateNoTimeValue.vue?vue&type=script&lang=js"
export * from "./DateNoTimeValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__